import { activityConstants } from "../_constants";

export function activity(
  state = {
    fetchingDetail: false,
    detail: {},
    activityFrequency: "timeline",
    detailItem: "0",
    offDayAlertsHidden: true,
    offWeekAlertsHidden: true,
  },
  action
) {
  switch (action.type) {
    case activityConstants.DAILY_STATUS_REQUEST:
    case activityConstants.WEEKLY_STATUS_REQUEST:
    case activityConstants.TIMELINE_REQUEST:
    case activityConstants.OFF_ALERTS_REQUEST:
      return {
        ...state,
        fetchingDetail: true,
      };
    case activityConstants.DAILY_STATUS_SUCCESS:
    case activityConstants.WEEKLY_STATUS_SUCCESS:
    case activityConstants.OFF_ALERTS_SUCCESS:
      return {
        ...state,
        fetchingDetail: false,
        detail: action.detail /*,
        detailItem: action.detail.available[action.detail.available.length - 1]*/,
      };
    case activityConstants.DAILY_STATUS_FAILURE:
    case activityConstants.WEEKLY_STATUS_FAILURE:
    case activityConstants.TIMELINE_FAILURE:
    case activityConstants.OFF_ALERTS_FAILURE:
      return {
        ...state,
        fetchingDetail: false,
      };
    case activityConstants.SET_ACTIVITY_FREQUENCY:
      return {
        ...state,
        activityFrequency: action.timescale,
        fetchingDetail: true,
        detailItem: "0",
      };
    case activityConstants.SET_DETAIL_ITEM:
      return {
        ...state,
        detailItem: action.item,
      };
    case activityConstants.SET_DAILY_OFF_ALERTS_TOGGLE:
      console.log("SET OFF TO: ", action.state);
      return {
        ...state,
        offDayAlertsHidden: action.state,
      };
    case activityConstants.SET_WEEKLY_OFF_ALERTS_TOGGLE:
      return {
        ...state,
        offWeekAlertsHidden: action.state,
      };
    case activityConstants.TIMELINE_SUCCESS:
      return {
        ...state,
        fetchingDetail: false,
        detail: action.detail,
      };
    default:
      return state;
  }
}
